/** Hidden chat-scoped working folder (`system/sessions/{conversationId}/`). */

export function isSessionScratchPath(path: string | null | undefined): boolean {
  const p = String(path || '').replace(/\\/g, '/')
  return p.startsWith('system/sessions/') || p.includes('/system/sessions/')
}

export function isSessionSoulStackPath(path: string | null | undefined): boolean {
  const p = String(path || '').replace(/\\/g, '/')
  return p.endsWith('/soul-stack.md') || p.endsWith('soul-stack.md')
}

export function isSessionSoulStackDisplayTitle(title: string | null | undefined): boolean {
  return String(title || '').trim().toLowerCase() === 'soul stack'
}

export function isSessionScratchDisplayTitle(title: string | null | undefined): boolean {
  const t = String(title || '').trim().toLowerCase()
  if (t === 'soul stack') return true
  if (t === 'session memory') return true
  if (t.startsWith('pointer:')) return true
  if (t === 'session scratch' || t.startsWith('session scratch ')) return true
  return false
}

export function isSessionScratchReference(ref: {
  id?: string
  path?: string
  title?: string
} | null | undefined): boolean {
  if (!ref) return false
  if (isSessionScratchPath(ref.path) || isSessionScratchPath(ref.id)) return true
  // First-prompt context inject stores id+title only (no path).
  if (!ref.path && isSessionScratchDisplayTitle(ref.title)) return true
  return false
}

export function isSessionSoulStackReference(ref: {
  id?: string
  path?: string
  title?: string
} | null | undefined): boolean {
  if (!ref) return false
  if (isSessionSoulStackPath(ref.path) || isSessionSoulStackPath(ref.id)) return true
  if (isSessionSoulStackDisplayTitle(ref.title)) return true
  return false
}

/** Chips under "Referenced documents" - soul stack is inspect-only; memory/pointers may be pointed at. */
export function visibleMessageReferences<T extends { id?: string; path?: string; title?: string }>(
  references: T[] | null | undefined,
): T[] {
  if (!references?.length) return []
  return references.filter((ref) => !isSessionSoulStackReference(ref))
}

/** New-chat AI Context from the open tab. Scratch docs stay off the first prompt. */
export function chatContextFromOpenDocument(
  documentId: string | null | undefined,
  documentTitle: string | null | undefined,
  documentPath: string | null | undefined,
): { contextDocumentId?: string; contextDocumentTitle?: string } {
  if (!documentId || isSessionScratchPath(documentPath)) return {}
  return {
    contextDocumentId: documentId,
    contextDocumentTitle: documentTitle ?? undefined,
  }
}
